import { Handshake } from '@phosphor-icons/react';

export default Handshake;
